import { isAlphanumeric } from './strings';

// The Stackery BE limits cloudformation stack names to be 40 characters
// This is smaller than the actual CF limit of 128 because the stack name
// is used as a prefix to resources names which can have lower limits
//
// A cloudformation stack name is the stackery stack name + envrionment name
// And the longest pre-seeded stack name is currently 17 characters long
// So we are keeping the max auto-generated environment name to be 22
const PREFIX = 'dev-';
const MAX_LENGTH = 22 - PREFIX.length;

export default (name) => {
  let environmentName = 'development';
  if (!isAlphanumeric(name)) {
    return environmentName;
  }

  let names = name.trim().toLowerCase().split(/\s+/);

  if (names.length > 1) {
    environmentName = names.slice(-1)[0];

    // If we have space, add the user's first initial to the envrionment name
    if (environmentName.length < MAX_LENGTH) {
      environmentName = names[0][0] + environmentName;
    }
  } else if (names.length === 1) {
    environmentName = names[0];
  }

  // trim the environment name to fit
  if (environmentName.length > MAX_LENGTH) {
    environmentName = environmentName.substring(0, MAX_LENGTH);
  }

  return PREFIX + environmentName;
};
